import { atom } from "jotai";

export const megaMenuOpenAtom = atom(false);
export const currentLinkAtom = atom("");
export const headerColorAtom = atom("");
export const scrollActiveAtom = atom(false);
